
import { defineComponent } from 'vue'

export default defineComponent({
  middleware: ['auth'],
  head: {
    htmlAttrs: {
      class: 'h-full',
    },
    bodyAttrs: {
      class: 'h-full assistant',
    },
  },
})
